import {Table} from "antd";
import React, {useState, useEffect, useRef} from "react";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import moment from "moment-timezone";
import CompleteTransferModal from "./completeTransferModal/CompleteTransferModal";

const TransferGroupingTable = ({transferGroups, refetch, page, setPage}) => {
    const [isOpenCompleteModal, setIsOpenCompleteModal] = useState(false);
    const [completeModalRecord, setCompleteModalRecord] = useState();

    const handleCompleteTransfer = record => {
        setIsOpenCompleteModal(true);
        setCompleteModalRecord(record);
    };

    const onPageChange = newPage => {
        setPage(newPage);
    };

    return (
        <>
            <Table
                style={{width: "100%"}}
                scroll={{x: "scroll"}}
                dataSource={transferGroups?.data}
                pagination={{
                    current: page,
                    pageSize: transferGroups?.pagination?.limit,
                    total: transferGroups?.pagination?.total,
                    onChange: onPageChange
                }}
            >
                <Table.Column title="Tarih" dataIndex="date" key="date" />
                <Table.Column title="Transfer Adı" dataIndex="name" key="name" />
                <Table.Column
                    title="Başlangıç Noktası"
                    dataIndex="from"
                    key="from"
                    render={from => <span>{from.name}</span>}
                />
                <Table.Column
                    title="Varış Noktası"
                    dataIndex="to"
                    key="to"
                    render={to => <span>{to.name}</span>}
                />
                <Table.Column
                    title="Cut Off Başlangıç Zamanı"
                    dataIndex="cutOffStartDate"
                    key="cutOffStartDate"
                    render={cutOffStartDate => (
                        <span>
                            {cutOffStartDate
                                ? moment(cutOffStartDate)
                                      .tz("Europe/Istanbul")
                                      .format("DD.MM.YYYY HH:mm")
                                : "-"}
                        </span>
                    )}
                />
                <Table.Column
                    title="Cut Off Bitiş Zamanı"
                    dataIndex="cutOffEndDate"
                    key="cutOffEndDate"
                    render={cutOffEndDate => (
                        <span>
                            {cutOffEndDate
                                ? moment(cutOffEndDate)
                                      .tz("Europe/Istanbul")
                                      .format("DD.MM.YYYY HH:mm")
                                : "-"}
                        </span>
                    )}
                />
                <Table.Column
                    title="Teslimat Sayısı"
                    dataIndex="totalShipmentCount"
                    key="totalShipmentCount"
                />
                <Table.Column
                    title="Paket Sayısı"
                    dataIndex="totalPackageCount"
                    key="totalPackageCount"
                />
                <Table.Column
                    title="Durum"
                    dataIndex="status"
                    key="status"
                    render={status => (
                        <span>
                            {status === "created"
                                ? "Oluşturuldu"
                                : status === "pending"
                                ? "Bekleniyor"
                                : "Tamamlandı"}
                        </span>
                    )}
                />
                <Table.Column
                    title="Aksiyon"
                    dataIndex="action"
                    key="action"
                    render={(text, record) => (
                        <CustomButton onClick={() => handleCompleteTransfer(record)}>
                            Bitiş Zamanını Düzenle
                        </CustomButton>
                    )}
                />
            </Table>
            <CompleteTransferModal
                isOpen={isOpenCompleteModal}
                onClose={() => setIsOpenCompleteModal(false)}
                record={completeModalRecord}
                refetch={refetch}
            />
        </>
    );
};

export default TransferGroupingTable;
